export class InningModel {

    public inning: number = 1;
    public awayRuns: string = '';
    public awayHits: string = '';
    public awayErrors: string = '';
    public homeRuns: string = '';
    public homeHits: string = '';
    public homeErrors: string = '';

    constructor(obj?: any) {
        if (obj) {
            this.inning = parseInt(obj.inning);
            this.awayRuns = obj.away_runs;
            this.awayHits = obj.away_hits;
            this.awayErrors = obj.away_errors;
            this.homeRuns = obj.home_runs;
            this.homeHits = obj.home_hits;
            this.homeErrors = obj.home_errors;
        }
    }
}